import common from './common'
import fields from './fields'

export default {
  common,
  fields,
}
